export default __webpack_public_path__ + "static/Facebook Mesanger-hero1-920d112b2d62d07d63804ae46ab4aff4.webp";